<template>
    <div id="container" role="region" :aria-label="ariaLabel" class="brightcove-video-container">
        <iframe :src="videoSrc"
                class="w-100"
                allowfullscreen
                allow="encrypted-media"
                frameborder="0">
        </iframe>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    const props = defineProps({
        accountId: { type: String, required: true },
        videoId: { type: String, required: true },
        ariaLabel: { type: String, required: true }
    });

    const videoSrc = computed(() => {
        return `https://players.brightcove.net/${props.accountId}/default_default/index.html?videoId=${props.videoId}`;
    });
</script>

<style scoped lang="css">
    .brightcove-video-container {
        min-height: 550px;
    }
    iframe {
        aspect-ratio: 16 / 9;
    }
</style>
